export default Object.freeze({
  loginBGI: require("@/static/images/login/backgroundImage.png"), // 登录页背景
  zdLogo: require("@/static/images/common/logo.png"), // 登录页 中德logo
  luojigouLogo: require("@/static/images/common/luojigouLogo.png"), // 登录页 逻辑狗logo
  downloadAPP: require("@/static/images/login/downloadAPP.png"), // 登录页 下载APP
  luojigouHead: require("@/static/images/login/luojigouHead.png"), // 登录页 逻辑狗头像
  loginByPwdOrCode: require("@/static/images/login/loginByPwdOrCode.png"), // 登录页 切换成用密码登录
  loginByQRCode: require("@/static/images/login/loginByQRCode.png"), // 登录页 切换成用二维码登录

  homeBGI: require("@/static/images/home/bgi.png"), // 首页背景
  bgi1: require("@/static/images/home/bgi1.png"), // 首页四个一级学科背景
  bgi2: require("@/static/images/home/bgi2.png"), // 首页四个一级学科背景
  bgi3: require("@/static/images/home/bgi3.png"), // 首页四个一级学科背景
  bgi4: require("@/static/images/home/bgi4.png"), // 首页四个一级学科背景
  markBGI1: require("@/static/images/home/markBGI1.png"), // 首页四个一级学科背景
  markBGI2: require("@/static/images/home/markBGI2.png"), // 首页四个一级学科背景
  markBGI3: require("@/static/images/home/markBGI3.png"), // 首页四个一级学科背景
  markBGI4: require("@/static/images/home/markBGI4.png"), // 首页四个一级学科背景
  homeTitle: require("@/static/images/home/homeTitle.png"), // 首页标题

  posterBGI: require("@/static/images/common/posterBGI.png"), // 海报背景
  shareBtn: require("@/static/images/common/shareBtn.png"), // 分享按钮
  downloadBtn: require("@/static/images/common/downloadBtn.png"), // 下载按钮
  noData: require("@/static/images/common/noData.png"), // 暂无记录
  history: require("@/static/images/common/history.png"), // 头部历史图标
  historyed: require("@/static/images/common/historyed.png"), // 头部历史图标已选中
  home: require("@/static/images/common/home.png"), // 头部首页图标
  luojigouMini: require("@/static/images/common/luojigouMini.png"), // 头部默认头像
  search: require("@/static/images/common/search.png"), // 头部搜索图标
  clearImg: require("@/static/images/common/clear.png"), // 头部学习记录清楚图标
  suo: require("@/static/images/home/suo.png"), // 首页锁图标
  firSub1: require("@/static/images/home/homeDetails/firSub1.png"), // 首页详情一级学科标题
  firSub2: require("@/static/images/home/homeDetails/firSub2.png"), // 首页详情一级学科标题
  firSub3: require("@/static/images/home/homeDetails/firSub3.png"), // 首页详情一级学科标题
  firSub4: require("@/static/images/home/homeDetails/firSub4.png"), // 首页详情一级学科标题
  section01: require("@/static/images/home/homeDetails/section01.png"), // 首页详情学段名称（被选中时）
  section02: require("@/static/images/home/homeDetails/section02.png"), // 首页详情学段名称（被选中时）
  section11: require("@/static/images/home/homeDetails/section11.png"), // 首页详情学段名称（被选中时）
  section12: require("@/static/images/home/homeDetails/section12.png"), // 首页详情学段名称（被选中时）
  section21: require("@/static/images/home/homeDetails/section21.png"), // 首页详情学段名称（被选中时）
  section22: require("@/static/images/home/homeDetails/section22.png"), // 首页详情学段名称（被选中时）
  section31: require("@/static/images/home/homeDetails/section31.png"), // 首页详情学段名称（被选中时）
  section32: require("@/static/images/home/homeDetails/section32.png"), // 首页详情学段名称（被选中时）
  class0: require("@/static/images/home/homeDetails/class0.png"), // 首页详情背景
  class1: require("@/static/images/home/homeDetails/class1.png"), // 首页详情背景
  class2: require("@/static/images/home/homeDetails/class2.png"), // 首页详情背景
  class3: require("@/static/images/home/homeDetails/class3.png"), // 首页详情背景
  leftBtn: require("@/static/images/home/homeDetails/left.png"), // 首页详情轮播图左箭头
  rightBtn: require("@/static/images/home/homeDetails/right.png"), // 首页详情轮播图右箭头

  fullScreenBtn: require("@/static/images/home/courseDetails/fullScreenBtn.png"), // 课件全屏按钮
  returnFullScreen: require("@/static/images/home/courseDetails/returnFullScreen.png"), // 课件全屏返回按钮

  collectBtn: require("@/static/images/home/courseDetails/collectBtn.png"), // 课程详情未收藏按钮
  collectedBtn: require("@/static/images/home/courseDetails/collectedBtn.png"), // 课程详情收藏按钮
  list01: require("@/static/images/home/courseDetails/list01.png"), // 课程详情列表按钮
  list02: require("@/static/images/home/courseDetails/list02.png"), // 课程详情列表按钮
  list11: require("@/static/images/home/courseDetails/list11.png"), // 课程详情列表按钮
  list12: require("@/static/images/home/courseDetails/list12.png"), // 课程详情列表按钮
  list21: require("@/static/images/home/courseDetails/list21.png"), // 课程详情列表按钮
  list22: require("@/static/images/home/courseDetails/list22.png"), // 课程详情列表按钮
  list31: require("@/static/images/home/courseDetails/list31.png"), // 课程详情列表按钮
  list32: require("@/static/images/home/courseDetails/list32.png"), // 课程详情列表按钮

  myBGI: require("@/static/images/my/bgi.png"), // 我的页面背景图
  PPTNext: require("@/static/images/search/PPTNext.png"), // 搜索页面PPT下一步按钮
  PPTNexted: require("@/static/images/search/PPTNexted.png"), // 鼠标经过时，搜索页面PPT下一步按钮
  lrList: require("@/static/images/my/lrList.png"), // 学习记录列表学段后面的背景
  closeBtn: require("@/static/images/my/closeBtn.png"), // 关闭按钮
  updateTime: require("@/static/images/my/updateTime.png"), // 更新时间小闹钟
  LRSeleted: require("@/static/images/my/LRSeleted.png") // 学习记录被选中的样式
});
